export default __webpack_public_path__ + "static/media/img_teaching_m.26b7e15c.jpg";